<div class="picture">
    <img *ngIf="isSVG" role="img" [src]="imageUrl" alt="{{ imageAlt }}" [ngClass]="imgClass" />
    <img *ngIf="!isSVG" src="{{ imageUrl }}" [attr.srcset]="imageUrl2x" alt="{{ imageAlt }}" [ngClass]="imgClass"/>
</div>
